import { Box, Text } from '@mantine/core';
import GameScreen from '../components/GameScreen';
import PlayerCircle from '../components/PlayerCircle';
import useViewportScale from '../hooks/useViewportScale';

function FinishedScreen({ roomCode, finalResults }) {
  const px = useViewportScale();

  if (!finalResults) return null;

  const winners = finalResults.winners || [];
  const scores = (finalResults.finalScores || []).sort((a, b) => b.score - a.score);
  const isTie = winners.length > 1;

  return (
    <GameScreen
      backgroundImage="/lobby-bg.png"
      introSound="/That was a fun game here are results.m4a"
      title={isTie ? 'Tie Game!' : `${winners[0]?.name} wins!`}
      contentPosition="top"
    >
      <Box style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '2rem',
        position: 'relative',
        zIndex: 1,
        marginTop: '1rem',
      }}>
        {/* Winners */}
        <Box style={{
          display: 'flex',
          gap: `${px(40)}px`,
          justifyContent: 'center',
          alignItems: 'flex-end',
        }}>
          {winners.map((winner, i) => (
            <Box key={winner.id} style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '0.5rem',
            }}>
              <PlayerCircle
                player={winner}
                index={i}
                size={px(300)}
                highlight
                animate
              />
              <Text style={{
                fontSize: '2rem',
                fontWeight: 700,
                color: '#FFD700',
                textShadow: '2px 2px 4px rgba(0,0,0,0.5)',
                textAlign: 'center',
              }}>
                {winner.score} points
              </Text>
            </Box>
          ))}
        </Box>

        {/* Leaderboard */}
        {scores.length > winners.length && (
          <Box style={{
            display: 'flex',
            gap: `${px(30)}px`,
            justifyContent: 'center',
            flexWrap: 'wrap',
          }}>
            {scores.slice(winners.length, 6).map((player, i) => (
              <Box key={player.id} style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '0.25rem',
              }}>
                <PlayerCircle
                  player={player}
                  index={winners.length + i}
                  size={px(160)}
                  animate
                />
                <Text style={{
                  fontSize: '1.2rem',
                  fontWeight: 600,
                  color: '#222',
                  textShadow: '1px 1px 0px rgba(255,255,255,0.8)',
                  textAlign: 'center',
                }}>
                  {player.score} pts
                </Text>
              </Box>
            ))}
          </Box>
        )}
      </Box>
    </GameScreen>
  );
}

export default FinishedScreen;
